import { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';

export interface PipelineTableSavedFiltersConfig {
  canAccessSaveFilters$: Observable<boolean>;
}
export const PIPELINE_TABLE_SAVED_FILTERS_CONFIG_TOKEN = new InjectionToken<PipelineTableSavedFiltersConfig>(
  'general dependency data for the pipeline table saved filters',
);

export const HAS_ACCESS_TO_SAVE_FILTERS = new InjectionToken<Observable<boolean>>(
  'token for the access to save filters',
);
